import { useQuery } from '@tanstack/react-query';
import {
  getService,
  listAllServices,
  listCategories,
  listGroupedServices,
  listSubCategoriesByCategory,
  type ListServicesParams,
} from '../api/services';

export function useAllServices(params?: ListServicesParams) {
  return useQuery({
    queryKey: ['services', 'all', params],
    queryFn: () => listAllServices(params),
    staleTime: 60_000,
  });
}

export function useCategories() {
  return useQuery({
    queryKey: ['services', 'categories'],
    queryFn: listCategories,
    staleTime: 5 * 60_000,
  });
}

// Landing mega-menu data. Always returns all 5 category buckets in fixed
// order so the menu can render a consistent 5-column grid.
export function useGroupedServices() {
  return useQuery({
    queryKey: ['services', 'grouped'],
    queryFn: listGroupedServices,
    staleTime: 5 * 60_000,
  });
}

// Powers the admin sub-category dropdown. Server merges hard-coded defaults
// with previously persisted custom values so "type once, reappears later"
// works without any client-side bookkeeping.
export function useSubCategoriesByCategory() {
  return useQuery({
    queryKey: ['services', 'sub-categories'],
    queryFn: listSubCategoriesByCategory,
    staleTime: 5 * 60_000,
  });
}

export function useService(id: string | undefined) {
  return useQuery({
    queryKey: ['service', id],
    queryFn: () => getService(id as string),
    enabled: !!id,
    staleTime: 60_000,
  });
}
